import React from 'react';
import NumberOfContracts from './NumberOfContracts';
import ContractAmounts from './ContractAmounts';
import TendersVsDANumber from './TendersVsDANumber';
import TendersVsDAValue from './TendersVsDAValue';
import TopSuppliersContractValue from './TopSuppliersContractValue';
import SavingsAmount from './SavingsAmount';
import CompetitionCompletionTimeByRfqProcess from './CompetitionCompletionTimeByRfqProcess';
import ContractCreationTime from './ContractCreationTime';
import Top10Suppliers from './Top10Suppliers';

const ContractsDashboardComponent = ({
                                         top10Suppliers,
                                         totalNumberOfContracts,
                                         numberOfContracts,
                                         totalContractAmount,
                                         contractAmounts,
                                         tendersVsDaNumber,
                                         tendersVsDaValue,
                                         topSuppliersContractValue,
                                         savingsAmountByYear,
                                         savingsAmountByDepartment,
                                         savingsAmountByRfqProcess,
                                         competitionCompletionTimeByRfqProcess,
                                         contractCreationTimeByYear,
                                         contractCreationTimeByDepartment,
                                     }) => {
    return (
        <div>
            <Top10Suppliers
                data={top10Suppliers}
            />

            <NumberOfContracts
                total={totalNumberOfContracts}
                data={numberOfContracts}
            />

            <ContractAmounts
                total={totalContractAmount}
                data={contractAmounts}
            />

            <div className="row">
                <div className="col-md-6">
                    <TendersVsDANumber
                        data={tendersVsDaNumber}
                    />
                </div>
                <div className="col-md-6">
                    <TendersVsDAValue
                        data={tendersVsDaValue}
                    />
                </div>
            </div>

            <TopSuppliersContractValue
                data={topSuppliersContractValue}
            />

            <SavingsAmount
                byYear={savingsAmountByYear}
                byDepartment={savingsAmountByDepartment}
                byRfqProcess={savingsAmountByRfqProcess}
            />

            <CompetitionCompletionTimeByRfqProcess
                data={competitionCompletionTimeByRfqProcess}
            />

            <ContractCreationTime
                byYear={contractCreationTimeByYear}
                byDepartment={contractCreationTimeByDepartment}
            />
        </div>
    );
}

export default ContractsDashboardComponent;